export default __webpack_public_path__ + "locales/es/Common.json?hash=dcc34c67b9755997c9222582e3440bcb";